import { RouteLocation } from 'vue-router';
import { useProfileInfo } from '@models/profile/useCurrentProfile';
import { usePermission } from '@models/profile/useProfilePermission';
import analyticsService from '@assets/services/analytics.service';

const { profileInfo, profileCurrentMenu, profileCurrentProduct } = useProfileInfo();
const { hasExperienceV4Permission, getPermission } = usePermission();

export default {
    beforeEnterExperience(to: RouteLocation, from: RouteLocation, next: any) {
        analyticsService.sendProductActiveTime('ptx');
        next();
    },
    beforeEnterExperienceV3(to: RouteLocation, from: RouteLocation, next: any) {
        if (to.params?.path?.[0] === 'campaign' && hasExperienceV4Permission.value) {
            gotoV4(to, next);
        } else next();
    },
    beforeEnterExperienceV4(to: RouteLocation, from: RouteLocation, next: any) {
        if (nextGotoV3()) gotoV3(to, next);
        else next();
    },
    beforeEnterEngagement(to: any, from: any, next: any) {
        if (to.params.updatePermission) {
            getPermission(
                () => {
                    enterEngagement(to, next);
                },
                (err: any) => {
                    next();
                }
            );
        } else {
            enterEngagement(to, next);
        }
    }
};

async function enterEngagement(to: any, next: any) {
    if (nextGotoV3()) {
        gotoV3(to, next);
        return;
    }
    next();
}

function nextGotoV3() {
    return (
        !hasExperienceV4Permission.value ||
        (profileCurrentProduct.value?.key === 'experience' &&
            profileCurrentMenu.value &&
            profileCurrentMenu.value?.key !== 'CAMPAIGN')
    );
}

function gotoV3(to: RouteLocation, next: any) {
    next({
        name: 'ExperienceV3',
        params: {
            sid: profileInfo.value?.sid || to.params.sid
            // path: ['campaign', 'report']
        }
    });
}

function gotoV4(to: RouteLocation, next: any) {
    next({
        name: 'ExperienceList',
        params: {
            sid: profileInfo.value?.sid || to.params.sid
        }
    });
}

function gotoExperienceList(to: RouteLocation, next: any, experienceCount: number) {
    if (experienceCount === 0) {
        const params = to.params.template
            ? {
                  sid: profileInfo.value?.sid || to.params.sid,
                  template: to.params.template
              }
            : {
                  sid: profileInfo.value?.sid || to.params.sid
              };
        next({
            name: 'ExperienceListGuide',
            params
        });
        return;
    }
    next();
}
